/** Læser opgavetype-id fra API-data, uanset casing. 0 og tomt tæller ikke. */
export function laesOpgavetype(data: unknown): number | null {
    if (!data || typeof data !== "object") {
        return null;
    }

    const record = data as Record<string, unknown>;
    for (const key of [
        "opgavetype",
        "Opgavetype",
        "opgaveType",
        "OpgaveType",
        "opgavetypeid",
        "Opgavetypeid",
        "opgaveTypeId",
        "OpgaveTypeId"
    ]) {
        const value = record[key];
        if (value === undefined || value === null || value === "" || value === 0 || value === "0") {
            continue;
        }

        const parsed = Number(value);
        if (!Number.isNaN(parsed) && parsed !== 0) {
            return parsed;
        }
    }

    return null;
}

export function harOpgavetype(data: unknown): boolean {
    return laesOpgavetype(data) != null;
}
